import React from 'react';
import { Control, Fieldset } from 'react-redux-form';
import {
  enumStates,
  enumCountries,
  PLACEHOLDER_OPT,
  folioAllowedSpecialChars } from './Schemas/baseRrf';
import Select from './Controls/Select';
import InputField from './Controls/Field';
import {
  validateZipcode,
  validateAddress } from './Validators';

const getFields = (required, noPOBoxes) => ([
  {
    model: '.line1',
    RRFComp: Control.text,
    control: {
      placeholder: `Street Address ${noPOBoxes ? '(No P.O. Boxes)' : ''}`,
      maxLength: 35,
      errors: {
        required: val => required && (!val || !val.length),
        address: val => val && !validateAddress(val),
      },
    },
    error: {
      messages: {
        required: 'Please provide a Street Address.',
        address: val => `The following characters are not allowed: ${
          val.replace(folioAllowedSpecialChars, '').split('')
            .filter((item, pos, self) => self.indexOf(item) === pos)
            .join('')}`,
      },
    },
  },
  {
    model: '.line2',
    RRFComp: Control.text,
    control: {
      maxLength: 35,
      placeholder: 'Address Line 2',
      errors: {
        address: val => val && !validateAddress(val),
      },
    },
    error: {
      messages: {
        address: val => `The following characters are not allowed: ${
          val.replace(folioAllowedSpecialChars, '').split('')
            .filter((item, pos, self) => self.indexOf(item) === pos)
            .join('')}`,
      },
    },
  },
  {
    model: '.city',
    RRFComp: Control.text,
    control: {
      maxLength: 25,
      placeholder: 'City',
      errors: {
        required: val => !val || !val.length,
      },
    },
    error: {
      messages: {
        required: 'Please provide a City.',
      },
    },
  },
  {
    model: '.state',
    RRFComp: Control,
    control: {
      component: Select,
      errors: {
        required: val => required && (!val || !val.length || val === PLACEHOLDER_OPT),
      },
    },
    error: {
      messages: {
        required: 'Please select a State.',
      },
    },
  },
  {
    model: '.zipcode',
    RRFComp: Control.text,
    control: {
      maxLength: 5,
      placeholder: 'ZIP Code',
      errors: {
        required: val => required && (!val || !val.length),
        isZipCode: val => val && !validateZipcode(val),
      },
    },
    error: {
      messages: {
        required: 'Please provide a ZIP Code.',
        isZipCode: val => `${val} is not a valid ZIP Code.`,
      },
    },
  },
  {
    model: '.country',
    RRFComp: Control,
    control: {
      component: Select,
      errors: {
        required: val => required && (!val || !val.length || val === PLACEHOLDER_OPT),
      },
    },
    error: {
      messages: {
        required: 'Please select a Country.',
      },
    },
  },
]);

const Address = ({ addrPath, required, noPOBoxes = false }) => {
  const fields = getFields(required, noPOBoxes);
  return (
    <Fieldset model={addrPath}>
      {fields.map((field, idx) => (idx < 3 ?
        <InputField key={field.model} fieldProps={field} /> : null))}
      <InputField key={fields[3].model} fieldProps={fields[3]}>
        {Object.keys(enumStates).map(key => (
            (key === PLACEHOLDER_OPT) ?
              <option key={key} disabled value={key}>{enumStates[key]}</option>
            : <option key={key} value={key}>{enumStates[key]}</option>
          ))}
      </InputField>
      <InputField key={fields[4].model} fieldProps={fields[4]} />
      <InputField key={fields[5].model} fieldProps={fields[5]}>
        {Object.keys(enumCountries).map(key => (
            (key === PLACEHOLDER_OPT) ?
              <option key={key} disabled value={key}>{enumCountries[key]}</option>
            : <option key={key} value={key}>{enumCountries[key]}</option>
          ))}
      </InputField>
    </Fieldset>
  );
};

export default Address;




// WEBPACK FOOTER //
// ./src/components/Forms/Address.js